export default __webpack_public_path__ + "static/media/plus-logo.f5ac9f90.svg";